import React from 'react';

const PDFViewerShimmer = () => {
  return (
    <div className="flex w-full h-screen">

      
      <div className="flex-1 bg-white p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="h-6 w-1/2 bg-gray-500 rounded animate-pulse"></div>
          <div className="h-6 w-1/3 bg-gray-500 rounded animate-pulse"></div>
        </div>

        <div className="h-[85vh] border rounded bg-gray-100 flex items-center justify-center animate-pulse">
          <div className="text-zinc-600">Generating PDF...</div>
        </div>
      </div>
    </div>
  );
};

export default PDFViewerShimmer;
